import { render, staticRenderFns } from "./TextEditorModal.vue?vue&type=template&id=4c5ad01a"
import script from "./TextEditorModal.vue?vue&type=script&lang=js"
export * from "./TextEditorModal.vue?vue&type=script&lang=js"
import style0 from "./TextEditorModal.vue?vue&type=style&index=0&id=4c5ad01a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports